import { Box, Flex, IconButton, Text } from '@chakra-ui/react'
import { trackEvent } from '@lib/clinician-tracking'
import React, { useEffect, useState } from 'react'
import {
  useGrowsurfControllerGetUnseenRewards,
  useGrowsurfControllerMarkRewardsAsSeen
} from '~/clinician-api'
import { useExperienceManager } from '@hooks'
import { ReferralModalView } from '../../../components/referral-modal'
import { useReferralModalGlobal } from '../../../components/referral-modal/provider'

type ReferralNotificationProps = {}

const ReferralNotification: React.FC<ReferralNotificationProps> = () => {
  const { openReferralModal } = useReferralModalGlobal()
  const { usageBasedPricingEnabled } = useExperienceManager()
  const { mutate: markRewardsAsSeen } = useGrowsurfControllerMarkRewardsAsSeen()
  const { data: unseenRewardsData, refetch: refetchUnseenRewards } =
    useGrowsurfControllerGetUnseenRewards()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (
      unseenRewardsData?.newFreeMonthsAdded &&
      unseenRewardsData.newFreeMonthsAdded > 0
    ) {
      setVisible(true)
    }
  }, [unseenRewardsData])

  if (!visible || !unseenRewardsData || !unseenRewardsData.newFreeMonthsAdded) {
    return null
  }

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation()
    markRewardsAsSeen(undefined, {
      onSuccess: () => {
        setVisible(false)
        refetchUnseenRewards()
        trackEvent('Rewards Notification -> Closed Notification')
      }
    })
  }

  const handleClick = () => {
    openReferralModal(ReferralModalView.RewardNotification)
    trackEvent('Rewards Notification -> Clicked Notification')
  }

  return (
    <>
      <Box
        bg="rgba(246, 247, 255, 0.8)"
        p="12px"
        borderRadius="8px"
        border="1px solid rgba(45, 84, 232, 0.04)"
        mb={4}
        cursor="pointer"
        onClick={handleClick}
        _hover={{
          bg: 'rgba(246, 247, 255, 0.9)',
          boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.05)'
        }}
      >
        <Flex alignItems="center" gap={3}>
          <Flex
            bg="rgba(45, 84, 232, 0.1)"
            p={2}
            borderRadius="md"
            width="48px"
            height="48px"
            alignItems="center"
            justifyContent="center"
          >
            <Box as="span" fontSize="24px">
              🎁
            </Box>
          </Flex>
          <Box>
            <Text fontWeight="bold" fontSize="md">
              You earned rewards!
            </Text>
            <Text fontSize="sm" color="gray.600">
              {usageBasedPricingEnabled
                ? 'Get $150 of additional credits applied to your next purchase'
                : `Enjoy ${unseenRewardsData.newFreeMonthsAdded} free ${
                    unseenRewardsData.newFreeMonthsAdded === 1 ? 'month' : 'months'
                  } of Blueprint!`}
            </Text>
          </Box>
          <Box ml="auto">
            <IconButton
              aria-label="Close"
              icon={<span>✕</span>}
              size="sm"
              variant="ghost"
              _focus={{ outline: 'none' }}
              onClick={handleClose}
            />
          </Box>
        </Flex>
      </Box>
    </>
  )
}

export default ReferralNotification
